import Inputmask from 'inputmask';

/**
 * Initialize phone number input masking
 * Applies a Ukrainian phone number format mask (+38 (0XX) XXX-XX-XX) 
 * to all telephone input fields on the page
 */

// Select all input elements with type="tel"
const phoneNumberInputs = document.querySelectorAll('input[type=tel]');

// Only proceed if telephone inputs are found
if (phoneNumberInputs.length > 0) {
    // Create mask instance with Ukrainian phone number format
    const phoneInputMask = new Inputmask({
        mask: '+38 (099) 999-99-99',
        placeholder: '_',
        clearMaskOnLostFocus: true,
        showMaskOnHover: false
    });

    // Apply mask to all telephone inputs
    phoneInputMask.mask(phoneNumberInputs);
}
